import styles from "./back-btn.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Typography } from "antd";

import ChevronLeftIcon from "@/icons/ChevronLeftIcon";

const { Title } = Typography;

const BackBtn = ({ children, onClick }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else {
      navigate(-1);
    }
  };

  return (
    <Link onClick={handleClick} className={`${styles.link} back-btn`}>
      <div className={styles.arrow}>
        <ChevronLeftIcon />
      </div>
      <Title level={2} className={styles.title}>
        {children}
      </Title>
    </Link>
  );
};

export default BackBtn;
